<template>
  <div>
    <div class="img-bg" @click="$emit('hideImg')"></div>
    <img class="pre-img" :src="imgSrc" alt="" />
  </div>
</template>
<style src="./preview.css" scoped></style>

<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import mixins from "../../common/mixin";
import application from "../../common/application";
export default {
  name: "companyIntro",
  props: {
    imgSrc: {
      type: String,
      required: true,
      default: "",
    },
  },
  components: {
    swiper,
    swiperSlide,
  },
  data: () => ({
    dataList: [],
    application: application,
  }),
  mixins: [mixins],
  created() {
    this.getData();
  },
  methods: {
    //获取数据
    getData() {
      let data = {
        pageIndex: 0,
        pageSize: 30,
      };
      this.request({
        url: "/web/introduce/honor",
        data: data,
        success: (response) => {
          this.dataList = response.data.records;
          // console.log(this.bannerList)
        },
        error: (response) => {
          this.$Message.error(response.message);
        },
        complete: () => {},
      });
    },
  },
};
</script>

<style >
.img-bg {
  width: 100vw;
  height: 100vh;
  position: fixed;
  top: 0;
  background: #000000b8;
  z-index: 2;
}
.pre-img {
  width: 60vw;
  margin: 10vh auto;
  position: fixed;
  top: 0;
  left: 20vw;
  z-index: 3;
}
</style>



// WEBPACK FOOTER //
// src/components/preview/preview.vue